export default __webpack_public_path__ + "static/media/agendar_luego.85aad133.png";